import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Table from '../../../components/Table/Table';
import Button from '../../../components/Button/Button';
import Dropdown from '../../../components/Dropdown/Dropdown';
import editIcon from '../../../assets/editIcon.png';
import editInactive from '../../../assets/tokens/editInactive.png';
import eyeOff from '../../../assets/tokens/eyeOff.png';
import eyeOn from '../../../assets/tokens/eyeOn.png';
import toggleActive from '../../../assets/toggleActive.png';
import toggleInactive from '../../../assets/toggleInactive.png';
import trashActive from '../../../assets/tokens/trashActive.png';
import trashInactive from '../../../assets/tokens/trashInactive.png';
import './Tokens.css';
//services
import { tokensService } from '../../../services/Tokens';
//components
import Badge from '../../../components/Badge/Badge';
import ModalAlert from '../../../components/ModalAlert/ModalAlert';
import Modal from '../../../components/Modal/Modal';
import Filters from '../../../components/Filters/Filters';
import MenuDropdown from '../../../components/MenuDropdown/MenuDropdown';
import Tooltip from '../../../components/Tooltip/Tooltip';

const Tokens = () => {
  const navigate = useNavigate();
  const [isStatusFilterOpen, setIsStatusFilterOpen] = useState(false);
  const [tokens, setTokens] = useState([]);
  const [selectedToken, setSelectedToken] = useState(null);
  const [totalItems, setTotalItems] = useState(0);
  const [isModalAlertOpen, setIsModalAlertOpen] = useState(false);
  const [titleAlert, setTitleAlert] = useState('Change status');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [titleModal, setTitleModal] = useState('');
  const [messageModal, setMessageModal] = useState('');
  const [isErrorModal, setIsErrorModal] = useState(false);
  const [isTokenDeleted, setIsTokenDeleted] = useState(false);
  const [currentPage, setCurrentPage] = useState(1)
  
  const columns = [
    { header: 'Package name', field: 'name' },
    { header: 'Quantity', field: 'tokens' },
    { header: 'Price', field: 'price' },
    { 
      header: 'Status',
      render: (row) => <Badge status={row.status} />
    },
    {
      header: '',
      render: (row) => (
        <Tooltip text="Edit this package">
          <button 
            className="edit-btn" 
            onClick={() => handleEdit(row)}
          >
            <img src={row.status === 'active' ? editIcon : editInactive} alt="Edit" />
          </button>
        </Tooltip>
      )
    },
    {
      header: '',
      render: (row) => (
        <Tooltip text="View details of this package">
          <button 
            className="edit-btn" 
            onClick={() => handleDetail(row)}
          >
            <img src={eyeOn} alt="Edit" />
          </button>
        </Tooltip>
      )
    },
    {
      header: '',
      render: (row) => (
        <Tooltip text="Change the status of this package">
          <button 
            className="edit-btn" 
            onClick={() => handleToggle(row)}
          >
            <img src={row.status === 'active' ? toggleActive : toggleInactive} alt="Toggle" />
          </button>
        </Tooltip>
      )
    },
    {
      header: '',
      render: (row) => (
        <Tooltip text="Delete this package">
          <button 
            className="delete-btn" 
            onClick={() => handleDelete(row)}  
          >
            <img src={row.status === 'active' ? trashActive : trashInactive} alt="Share" />
          </button>
        </Tooltip>
      )
    }
  ];

  useEffect(() => {
    fetchTokens();
  }, [currentPage]);

  const fetchTokens = async (filters) => {
    console.log(filters);
    const status = filters?.status ? filters.status : null;
    const tokens_min = filters?.quantity ? filters.quantity : null;
    const tokens_max = filters?.quantity ? filters.quantity : null;
    const price_min = filters?.price_min ? filters.price_min : null;
    const price_max = filters?.price_max ? filters.price_max : null;
    try {
      const params = {
        page: currentPage,
        items_per_page: 10,
        ...(status && { status }),
        ...(tokens_min && { tokens_min }),
        ...(tokens_max && { tokens_max }),
        ...(price_min && { price_min }),
        ...(price_max && { price_max })
      };
      const response = await tokensService.getList(params);
      if(response.status === "success"){
        const data = response.data.items.map(item => ({
          ...item,
          status: item.is_deleted ? 'deleted' : item.status
        }));
        setTokens(data);
        setTotalItems(response.data.total);
      }else{
        setTokens([]);
        setTotalItems(0);
      }
    } catch (error) {
      console.error('Error fetching tokens:', error);
    }
  };

  const handleDetail = (row) => {
    navigate(`/dashboard/tokens/edit-token/${row.id}`, {
      state: {
        action: 'detail',
        token: row
      }
    });
  };

  const handleEdit = (row) => {
    if(row.status === 'active'){
      navigate(`/dashboard/tokens/edit-token/${row.id}`, {
        state: {
          action: 'edit',
          token: row
        }
      });
    }else if(row.is_deleted === true){
      setTitleModal('Deleted');
      setMessageModal('The token was deleted, no action can be taken');
      setIsErrorModal(true);
      setIsModalOpen(true);
    }else{
      setTitleModal('Disabled');
      setMessageModal('No is possible to edit a disabled token');
      setIsErrorModal(true);
      setIsModalOpen(true);
    }
  };

  const handleToggle = (row) => {
    setSelectedToken(row);
    setTitleAlert('Change status');
    setIsTokenDeleted(false);
    setIsModalAlertOpen(true);
  };

  const handleDelete = (row) => {
    setSelectedToken(row);
    setTitleAlert('Delete ');
    setIsTokenDeleted(true);
    setIsModalAlertOpen(true);
  };

  const handleToggleConfirm = async () => {
    console.log('Toggling token:', selectedToken);
    setIsModalAlertOpen(false);
    try {
      const status = selectedToken.status === 'active' ? 'disabled' : 'active';
      const response = await tokensService.togglePack(selectedToken.id, status);
      if (response.status === 'success') {
        setTitleModal('Updated');
        setMessageModal('Successfully updated');
        setIsErrorModal(false);
        setIsModalOpen(true);
        fetchTokens();
      }else{
        setTitleModal('Error changing status');
        setMessageModal('Failed to change status');
        setIsErrorModal(true);
        setIsModalOpen(true);
      }
    } catch (error) {
      console.error('Error updating token:', error);
      setTitleModal('Error changing status');
      setMessageModal('Failed to change status');
      setIsErrorModal(true);
      setIsModalOpen(true);
    }
    
  };

  const handleDeleteConfirm = async () => {
    setIsModalAlertOpen(false);
    if(selectedToken.status === 'disabled'){
      setTitleModal('Error deleting ');
      setMessageModal('No is possible to delete a disabled token');
      setIsErrorModal(true);
      setIsModalOpen(true);
      return;
    }else if(selectedToken.is_deleted === true){
      setTitleModal('Deleted');
      setMessageModal('The token was deleted, no action can be taken');
      setIsErrorModal(true);
      setIsModalOpen(true);
      return;
    }
    try {
      const response = await tokensService.deletePack(selectedToken.id);
      if (response.status === 'success') {
        setTitleModal('Deleted');
        setMessageModal('Successfully deleted');
        setIsErrorModal(false);
        setIsModalOpen(true);
        fetchTokens();
      }else{
        setTitleModal('Error deleting token');
        setMessageModal('Failed to delete token');
        setIsErrorModal(true);
        setIsModalOpen(true);
      }
    } catch (error) {
      console.error('Error deleting token:', error);
      setTitleModal('Error deleting token');
      setMessageModal('Failed to delete token');
      setIsErrorModal(true);
      setIsModalOpen(true);
    }
    
  };

  return (
    <div className="tokens-page">
      <div className="tokens-container">
        <div className="actions-bar">
          <div className="content-filter">
            <Filters
              filters={[
                {
                  label: 'Status',
                  id: 'status',
                  type: 'checkbox',
                  options: ['active', 'inactive']
                },
                {
                  label: 'Quantity',
                  id: 'quantity',
                  type: 'number',
                  placeholder: 'Quantity'
                },
                {
                  label: 'Price',
                  id: 'price',
                  type: 'number-range',
                  placeholder: '$',
                  placeholder2: '$'
                }
              ]}
              onApplyFilters={(filters) => fetchTokens(filters)}
            />
          </div>
          <div className="action-buttons">
            <Button
              onClick={() => navigate('/dashboard/tokens/new-token')}
              variant="primary"
              borderRadius={6}
            >
              New package
            </Button>
            <MenuDropdown
              options={[
                { label: 'Support', onClick: () => {
                  navigate('/dashboard/tokens/support-token');
                } },
                { label: 'Manage tokens', onClick: () => {
                  navigate('/dashboard/tokens');
                } },
                { label: 'Download', onClick: () => {
                  console.log('Download clicked');
                } },
              ]}
            />
          </div>
        </div>
        <Table
          data={tokens}
          totalItems={totalItems}
          columns={columns}
          itemsPerPage={9}
          columnsShare={4}
          currentPage={currentPage}
          onPageChange={(page) => {
            setCurrentPage(page);
          }}
        />
        <ModalAlert
          isOpen={isModalAlertOpen}
          onClose={() => setIsModalAlertOpen(false)}
          title={{text: titleAlert, highlight: 'token'}}
          message="Are you sure confirm this action?"
          acecept={true}
          onAccept={isTokenDeleted ? handleDeleteConfirm : handleToggleConfirm}
        />
        <Modal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          title={{ text: titleModal, highlight: 'token' }}
          showConfirmButton={true}
          confirmText="Confirm"
          onConfirm={() => setIsModalOpen(false)}
          message={messageModal}
          error={isErrorModal}
        />
      </div>
    </div>
  );
};

export default Tokens;
